import _ from "lodash";
import colors from "assets/styles/mixins/colors.scss";
import { FormattedMessage } from "react-intl";
import { API_ERROR_CODE, LANG, QUERY_STATUS } from "constants/constants";
import { getFormattedDate } from "utils/functions";
import PropTypes from "prop-types";

export const formatStaff = (list) =>
  _.chain(list)
    .map((elm) => {
      return {
        label: elm?.full_name,
        value: elm?.id,
        assigned_branches: elm?.assigned_branches,
      };
    })
    .filter((elm) => elm !== null)
    .value();

export const ModalDetachmentText = ({
  id,
  defaultMessage,
  value,
  valueStyle,
  dot = false,
}) => (
  <>
    <FormattedMessage id={id} defaultMessage={defaultMessage} />
    {value && (
      <p className="modal-value" style={valueStyle}>
        {value}
        {dot && "."}
      </p>
    )}
  </>
);

ModalDetachmentText.propTypes = {
  id: PropTypes.string,
  defaultMessage: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueStyle: PropTypes.object,
  dot: PropTypes.bool,
};

export const valueStyleDetachment = {
  color: colors.violet,
  marginLeft: "5px",
  marginRight: "5px",
};
export const sentenceStyleDetachment = {
  color: colors.violet,
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
};

export const COLORS = {
  center: {
    bg: colors.lightYellow,
    input: colors.gamboge,
    status: "orange",
    legend: "traffic_light_explanation_orange",
  },
  left: {
    bg: colors.lightGreen,
    input: colors.chateauGreen,
    status: "green",
    legend: "traffic_light_explanation_green",
  },
  right: {
    bg: colors.lightRed,
    input: colors.alizarinCrimson,
    status: "red",
    legend: "traffic_light_explanation_red",
  },
};

export const getCustomTitle = (intl, customTitle) => {
  return (
    <div className="title" id="modal-title">
      {intl.formatMessage(customTitle).toUpperCase()}
    </div>
  );
};

export const getCustomDescription = ({
  customMessages,
  lang,
  getDescription,
  intl,
}) => {
  const errorMessageOption = (errorDetail) => {
    switch (errorDetail.code) {
      case API_ERROR_CODE.END_DATE_BEFORE_BILL:
      case API_ERROR_CODE.START_DATE_AFTER_BILL:
        return `${" " + getFormattedDate(errorDetail?.message, lang)}.`;
      case API_ERROR_CODE.INVALID_MISSION_NAME:
        return `"${errorDetail.params.value}" ${intl.formatMessage({
          id: "is_not_valid_new_name",
          defaultMessage: "n'est pas un nouveau nom valide.",
        })}`;
      default:
        return "";
    }
  };

  return customMessages?.map((message) => {
    const { errorsDetail, missionName } = message || {};
    return (
      errorsDetail && (
        <div
          className="description"
          id="modal-msg"
          style={{ textAlign: "left" }}
        >
          {errorsDetail?.length > 0 ? (
            <div style={{ color: colors.red }}>
              <p style={{ fontWeight: "bold" }}>
                {`${lang === LANG.FR ? "La mission" : "The"} ${
                  missionName ? `"${missionName}"` : ""
                } ${
                  lang === LANG.FR
                    ? "comporte les erreurs suivantes :"
                    : "mission contains the following errors:"
                }`}
              </p>
              <ul>
                {errorsDetail?.map((error, index) => {
                  const description = getDescription({
                    messageId: error?.messageId,
                    messageDefault: error?.messageDefault,
                  });
                  return (
                    <li key={`error-${index}-${error?.messageId}`}>
                      {description} {errorMessageOption(error)}
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : (
            <p
              style={{
                fontWeight: "bold",
                color: colors.chateauGreen,
              }}
            >
              {`${lang === LANG.FR ? "La Mission" : "The"} "${missionName}" ${
                lang === LANG.FR
                  ? "a bien été mise à jour."
                  : "mission has been updated."
              }`}
            </p>
          )}
        </div>
      )
    );
  });
};

export const handleCustomClass = ({ isCustomModale, isPending, isError }) =>
  [
    isCustomModale && !isPending && "custom",
    isPending
      ? "is-pending"
      : !isCustomModale && (isError ? "is-error" : "is-success"),
  ]
    .filter(Boolean)
    .join(" ");

export const customMessagesFormatted = ({ missions, apiErrorResponse }) =>
  missions
    ?.map((e1) => {
      return (
        e1?.isNewUpdate && {
          missionId: e1?.missionId,
          missionName: e1?.missionName,
          errorsDetail:
            apiErrorResponse?.find((e2) => e2.missionId === e1?.missionId)
              ?.errorsDetail || [],
        }
      );
    })
    .filter(Boolean);

export const updatedByDataHelper = ({ data, setData, modalData }) => {
  const newData = data.map((item) => {
    const user = modalData.find((u) => u.id === item.id);
    if (user && item.updated_by == null) {
      return {
        ...item,
        updated_by: user.updated_by,
      };
    }
    return item;
  });
  setData(newData);
};

export const validationModalTitleHelper = ({
  isCreateAction,
  isEditAction,
  isDeleteAction,
}) => {
  switch (true) {
    case isCreateAction:
      return "modal_validation_create_file";
    case isEditAction:
      return "modal_validation_edit_file";
    case isDeleteAction:
      return "modal_validation_delete_file";
    default:
      return null;
  }
};

export const commonOnCloseHandler = ({
  editEntityStatus,
  deleteEntityStatus,
  setDeleteEntityStatus,
  setEditEntityStatus,
  setIsOpen,
  setReadOnly,
  userScope,
  navigate,
}) => {
  setIsOpen(false);
  if (editEntityStatus === QUERY_STATUS.ERROR) {
    return;
  }
  setReadOnly(true);
  if (deleteEntityStatus === QUERY_STATUS.SUCCESS) {
    navigate(`/${userScope}/missions`);
    setDeleteEntityStatus(QUERY_STATUS.INITIAL);
  } else {
    setEditEntityStatus(QUERY_STATUS.INITIAL);
  }
};
